// extracted by mini-css-extract-plugin
export default {"root":"Button_root__INBDh","primary":"Button_primary__TE+XN","secondary":"Button_secondary__mqfb6"};